import { useQuery } from "@tanstack/react-query";
import membershipCore from "../core/membership.core";

export default function useMemberships() {
  return useQuery({
    queryKey: ["memberships"],
    queryFn: membershipCore.loadMemberships,
  });
}
